export const RenderPDF = ({ fileBlob }: { fileBlob: Blob }) => {
  return (
    <iframe
      className="blob-to-image h-full w-full"
      src={URL.createObjectURL(fileBlob)}
    />
  );
};
